var _rect, _path, _circle, _text, _text2, _text3, _circle2, _text4, _text5, _text6, _circle3, _text7, _text8, _text9, _circle4, _text0, _text1, _text10, _text11;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFleetcoreImplementationResponsibleIntelligencePathwayDesktop(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 1080,
    height: 250,
    viewBox: "0 0 1080 250",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "FleetCore desktop implementation pathway") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 1080,
    height: 250,
    rx: 28,
    fill: "#FFFFFF",
    stroke: "#D2E1F2",
    strokeWidth: 2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M138 80H942",
    stroke: "#D2E1F2",
    strokeWidth: 3,
    strokeDasharray: "5 8"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 138,
    cy: 80,
    r: 24,
    fill: "#087CFF"
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 138,
    y: 86,
    fill: "#fff",
    textAnchor: "middle",
    fontFamily: "Inter, Arial, sans-serif",
    fontSize: 12,
    fontWeight: 850
  }, "01")), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    x: 138,
    y: 139,
    fill: "#087CFF",
    textAnchor: "middle",
    fontFamily: "Inter, Arial, sans-serif",
    fontSize: 11,
    fontWeight: 850,
    letterSpacing: 1.3
  }, "CONFIGURE")), _text3 || (_text3 = /*#__PURE__*/React.createElement("text", {
    x: 138,
    y: 174,
    fill: "#07152A",
    textAnchor: "middle",
    fontFamily: "Inter, Arial, sans-serif",
    fontSize: 13,
    fontWeight: 750
  }, "Roles, assets and evidence rules")), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 406,
    cy: 80,
    r: 24,
    fill: "#FF2775"
  })), _text4 || (_text4 = /*#__PURE__*/React.createElement("text", {
    x: 406,
    y: 86,
    fill: "#fff",
    textAnchor: "middle",
    fontFamily: "Inter, Arial, sans-serif",
    fontSize: 12,
    fontWeight: 850
  }, "02")), _text5 || (_text5 = /*#__PURE__*/React.createElement("text", {
    x: 406,
    y: 139,
    fill: "#FF2775",
    textAnchor: "middle",
    fontFamily: "Inter, Arial, sans-serif",
    fontSize: 11,
    fontWeight: 850,
    letterSpacing: 1.3
  }, "PILOT")), _text6 || (_text6 = /*#__PURE__*/React.createElement("text", {
    x: 406,
    y: 174,
    fill: "#07152A",
    textAnchor: "middle",
    fontFamily: "Inter, Arial, sans-serif",
    fontSize: 13,
    fontWeight: 750
  }, "Focused fleet and real shifts")), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 674,
    cy: 80,
    r: 24,
    fill: "#087CFF"
  })), _text7 || (_text7 = /*#__PURE__*/React.createElement("text", {
    x: 674,
    y: 86,
    fill: "#fff",
    textAnchor: "middle",
    fontFamily: "Inter, Arial, sans-serif",
    fontSize: 12,
    fontWeight: 850
  }, "03")), _text8 || (_text8 = /*#__PURE__*/React.createElement("text", {
    x: 674,
    y: 139,
    fill: "#087CFF",
    textAnchor: "middle",
    fontFamily: "Inter, Arial, sans-serif",
    fontSize: 11,
    fontWeight: 850,
    letterSpacing: 1.3
  }, "VALIDATE")), _text9 || (_text9 = /*#__PURE__*/React.createElement("text", {
    x: 674,
    y: 174,
    fill: "#07152A",
    textAnchor: "middle",
    fontFamily: "Inter, Arial, sans-serif",
    fontSize: 13,
    fontWeight: 750
  }, "Thresholds, reports and workflow")), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 942,
    cy: 80,
    r: 24,
    fill: "#FF2775"
  })), _text0 || (_text0 = /*#__PURE__*/React.createElement("text", {
    x: 942,
    y: 86,
    fill: "#fff",
    textAnchor: "middle",
    fontFamily: "Inter, Arial, sans-serif",
    fontSize: 12,
    fontWeight: 850
  }, "04")), _text1 || (_text1 = /*#__PURE__*/React.createElement("text", {
    x: 942,
    y: 139,
    fill: "#FF2775",
    textAnchor: "middle",
    fontFamily: "Inter, Arial, sans-serif",
    fontSize: 11,
    fontWeight: 850,
    letterSpacing: 1.3
  }, "SCALE")), _text10 || (_text10 = /*#__PURE__*/React.createElement("text", {
    x: 942,
    y: 174,
    fill: "#07152A",
    textAnchor: "middle",
    fontFamily: "Inter, Arial, sans-serif",
    fontSize: 13,
    fontWeight: 750
  }, "Expand when the process is ready")), _text11 || (_text11 = /*#__PURE__*/React.createElement("text", {
    x: 540,
    y: 224,
    fill: "#536985",
    textAnchor: "middle",
    fontFamily: "Inter, Arial, sans-serif",
    fontSize: 11,
    fontWeight: 650
  }, "Focused rollout \xB7 measured refinement \xB7 operational ownership")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFleetcoreImplementationResponsibleIntelligencePathwayDesktop);
export default __webpack_public_path__ + "static/media/fleetcore-implementation-responsible-intelligence-pathway-desktop.db9e03db231fd491c09657026d11ccb4.svg";
export { ForwardRef as ReactComponent };